import React, { PropsWithChildren, useCallback, useContext, useMemo, useState } from 'react';
import { GlobalMenu, GlobalMenuState } from './GlobalMenues';

type GlobalMenuContext = {
  currentOpenMenu: GlobalMenuState;
  closeMenus: () => void;
  toggleMenu: (menu: GlobalMenu) => void;
  toggleNav: () => void;
  togglePAL: () => void;
  toggleSearch: () => void;
};

export const Context = React.createContext<GlobalMenuContext>({
  currentOpenMenu: 'NONE',
  closeMenus: () => null,
  toggleMenu: () => null,
  toggleNav: () => null,
  togglePAL: () => null,
  toggleSearch: () => null,
});

export const GlobalMenuStore: React.FC<PropsWithChildren> = function ({ children }) {
  const [currentOpenMenu, setCurrentOpenMenu] = useState<GlobalMenuState>(GlobalMenuState.NONE);
  const closeMenus = () => setCurrentOpenMenu(GlobalMenuState.NONE);
  const toggleMenu = useCallback(
    (menu: GlobalMenu) => setCurrentOpenMenu(prev => (prev === menu ? GlobalMenuState.NONE : menu)),
    []
  );
  const toggleNav = useCallback(() => toggleMenu(GlobalMenu.MAIN_NAVIGATION), [toggleMenu]);
  const togglePAL = useCallback(() => toggleMenu(GlobalMenu.PAL), [toggleMenu]);
  const toggleSearch = useCallback(() => toggleMenu(GlobalMenu.INSTANT_SEARCH), [toggleMenu]);

  const menu = useMemo(
    () => ({
      currentOpenMenu,
      closeMenus,
      toggleMenu,
      toggleNav,
      togglePAL,
      toggleSearch,
    }),
    [currentOpenMenu, toggleMenu, toggleNav, togglePAL, toggleSearch]
  );

  return <Context.Provider value={menu}>{children}</Context.Provider>;
};

export const useGlobalMenu = () => useContext(Context);
